import React from 'react'
import { withRouter } from 'react-router-dom'

import SideNav from '../components/SideNav'
import Toast from '../components/_common/Toast'

import AdminRoutes from './AdminRoutes'
import OwnerRoutes from './OwnerRoutes'
import GuestRoutes from './GuestRoutes'
import RouteIf from './RouteIf'

const PrivateRoutes = ({ role }) => {
  const isAdmin = Number(role) === 0
  const isOwner = Number(role) === 1
  const isGuest = Number(role) === 2

  // console.log('is admin: ', isAdmin)
  // console.log('is owner: ', isOwner)
  // console.log('is guest: ', isGuest)
  return (
    <main className="app container flex">
      <SideNav />
      <div className="main-container">
        <Toast />

        <RouteIf condition={isAdmin} path="/" component={AdminRoutes} />
        <RouteIf condition={isOwner} path="/" component={OwnerRoutes} />
        <RouteIf condition={isGuest} path="/" component={GuestRoutes} />

      </div>
    </main>

  )
}

export default withRouter(PrivateRoutes)



// WEBPACK FOOTER //
// ./src/routes/PrivateRoutes.jsx